import { render, staticRenderFns } from "./overlapAvatarCard.vue?vue&type=template&id=273e5e14&"
import script from "./overlapAvatarCard.vue?vue&type=script&lang=js&"
export * from "./overlapAvatarCard.vue?vue&type=script&lang=js&"
import style0 from "./overlapAvatarCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "overlapAvatarCard.vue"
export default component.exports